var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "bot_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 664.8 664.9"
    },
    viewBox: "0 0 664.8 664.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bot_svg__st2{fill:#fff;stroke:#4751a3;stroke-width:2.1407;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.bot_svg__st3{fill:#333ccd}.bot_svg__st6{fill:#d6d8f5}.bot_svg__st7{fill:#1d136d}.bot_svg__st8{fill:#2323a4}.bot_svg__st10{fill:#e1e1ff}.bot_svg__st14{fill:#69e6f6}")), /*#__PURE__*/React.createElement("g", {
    id: "bot_svg__Circle_00000104675336666569842080000003646598012359853985_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bot_svg__SVGID_1_",
    x1: 13.213,
    x2: 657.803,
    y1: 332.866,
    y2: 332.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d3e1f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#eaf1fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d2def0"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.5,
    cy: 332.9,
    rx: 322.3,
    ry: 320.9,
    style: {
      fill: "url(#bot_svg__SVGID_1_)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "bot_svg__SVGID_00000069399281246069393570000012379680198274771638_",
    cx: 335.5,
    cy: 332.9,
    rx: 322.3,
    ry: 320.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bot_svg__SVGID_00000059302350569222805210000013860498903708375434_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bot_svg__SVGID_00000069399281246069393570000012379680198274771638_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bot_svg__SVGID_00000059302350569222805210000013860498903708375434_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.3 687.8c4 37.2 2.9 81.5 85.1 81.5h1.4c82.2 0 81.1-44.3 85.1-81.5H247.3z",
    className: "bot_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3 712.6c-42.8 0-87.1-9.1-87.1-24.4s44.3-24.4 87.1-24.4c42.9 0 87.3 9.1 87.3 24.4s-44.4 24.4-87.3 24.4z",
    className: "bot_svg__st3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bot_svg__SVGID_00000180359801434390503480000008978389130779141819_",
    x1: 266.208,
    x2: 400.035,
    y1: 688.139,
    y2: 688.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67c3a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    style: {
      stopColor: "#69e4f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69e6f6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333 671.3c-31.6 0-66.8 6.9-66.8 16.8s35.2 16.8 66.8 16.8c31.7 0 67-6.9 67-16.8s-35.3-16.8-67-16.8z",
    style: {
      fill: "url(#bot_svg__SVGID_00000180359801434390503480000008978389130779141819_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bot_svg__XMLID_00000154426660547529964930000003298177865407170971_",
    d: "M460.4 462.5c-11.1-1.1-19.1-14.5-20-31.8-26.5 9.2-59.2 16.9-96.6 18.2-2.3.1-4.6.1-6.9.2h-7.4c-2.3 0-4.6-.1-6.9-.2-37.4-1.3-70.1-9.1-96.6-18.2-.9 17.3-8.9 30.6-20.1 31.8.3 3.2.5 6.5.8 9.8-.2-.2 36.8 203.4 36.8 203.4 18.1 7.5 49.5 17.9 89.9 17.9 40.1 0 71.4-10.4 89.4-17.9 11.7-64.9 36.8-203.4 36.8-203.4v0c.3-3.3.6-6.5.8-9.8z",
    className: "bot_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.5 415.4c-27.5-5.6-59.1-9.8-94.2-10.8-2.4-.1-4.8-.1-7.2-.2-.9 0-1.7-.1-2.6-.1h-10.6c-.9 0-1.7 0-2.6.1-2.4 0-4.8.1-7.2.2-35.1 1-66.7 5.2-94.2 10.8.1 0 .2.1.2.2h-.2c.9 3.1 1.4 6.4 1.7 9.9.2 2.8.2 5.5 0 8.1l2.1.6v.2c9.4 2.5 19.3 5 29.7 7.4 19.9 4.7 41.5 8.8 64.6 9.7 2.5.1 5 .1 7.5.2h7c2.5 0 5.1-.1 7.5-.2 23.2-.9 44.8-4.9 64.6-9.7 10.4-2.4 20.3-5 29.7-7.4v-.2l2.1-.6c-.2-2.6-.2-5.3 0-8.1.3-3.5.9-6.8 1.7-9.9h-.2c.4-.1.5-.2.6-.2z",
    style: {
      fill: "#333ccd",
      stroke: "#4751a3",
      strokeWidth: 2.1407,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.2 687.2c-16.5-3.6-29.9-8.4-39.5-12.4 0 0-35.5-193.7-35.4-193.6-.3-3.2-1.2-5.1-1.5-8.3 9.6-5.7 18.5-19.2 22.1-37.4 3.9 1.3 8.2 2.3 12.3 3.6-1.6 15-10.3 31.5-19.2 32.5.2 3.2.5 6.4.7 9.6-.1-.2 31.2 193.6 31.2 193.6 8.5 4 29.3 12.4 29.3 12.4zm98.3.1c16.5-3.6 29.9-8.4 39.5-12.4 0 0 35.5-193.7 35.4-193.6.3-3.2 1.2-5.1 1.5-8.3-9.6-5.7-18.5-19.2-22.1-37.4-3.9 1.3-8.2 2.3-12.3 3.6 1.6 15 10.3 31.5 19.2 32.5-.2 3.2-.5 6.4-.7 9.6.1-.2-31.2 193.6-31.2 193.6-8.5 4-29.3 12.4-29.3 12.4z",
    className: "bot_svg__st6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M328.9 439.2c-26.8 0-48.1-4-75.9-11.8-5.3-1.5-5.3-7.4.1-8.4 25.1-4.9 50.5-7.6 75.8-7.8 1.4 0 57.7 2.6 84.2 7.8 5.3 1.1 5.3 6.6.1 8.4-38.8 13.1-84.3 11.8-84.3 11.8z",
    className: "bot_svg__st7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.6 472.3c-4.2-.7-6.5-5.2-6.5-12.6 0-6.5 1.7-14.5 4.8-22.3 2.9-7.4 6.7-13.7 10.6-18 4.1-4.5 8.1-6.4 11.4-5.5 3.3.8 5.3 4.3 5.8 9.8.5 5.2-.4 11.9-2.6 19.2-2.3 7.6-5.8 14.9-9.9 20.5-3.9 5.4-8 8.6-11.7 9-.5 0-1.2 0-1.9-.1z",
    className: "bot_svg__st8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m509.4 256.2 1.8 58.3c.3 9.9-4.3 15-13.9 15.3l-10.7.3c1.6-24.6 2.5-50.2 2.6-76.8 0-3.8 0-7.6-.1-11.4l5.6-.2c9.4-.3 14.4 4.6 14.7 14.5zm-349 0-1.8 58.3c-.3 9.9 4.3 15 13.9 15.3l10.7.3c-1.6-24.6-2.5-50.2-2.6-76.8 0-3.8 0-7.6.1-11.4l-5.6-.2c-9.4-.3-14.3 4.6-14.7 14.5z",
    className: "bot_svg__st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bot_svg__XMLID_00000133503549002411775170000013980257110290542476_",
    d: "M495.5 302.5c0 88.7-71.9 112.4-160.6 112.4-88.7 0-160.6-23.7-160.6-112.4 0-73.7 29.7-146.5 107.2-168.9 4.7-1.4 9.6-2.5 14.6-3.5 4.4-.9 8.9-1.6 13.6-2.1 1.6-.2 3.3-.4 4.9-.5 6.5-.6 13.2-.9 20.3-.9 7.8 0 15.2.3 22.3.9 2.6.2 5.1.5 7.6.8 3.5.4 7 .9 10.3 1.5 3.3.5 6.5 1.2 9.6 1.9 88.6 19.6 110.8 94.7 110.8 170.8z",
    className: "bot_svg__st2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.9 380.2c-44.8 0-78-6.8-98.8-20.1-13.6-8.7-27.4-22.8-27.4-61.2 0-76.3 43.8-122.9 126.2-122.9 85.1 0 126.2 46.6 126.2 122.9 0 38.4-13.9 52.5-27.4 61.2-20.8 13.4-54 20.1-98.8 20.1z",
    className: "bot_svg__st3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.7 360.1c17.1 13.3 44.5 20 81.4 20.1 27.5 0 59.5-2.6 82-20.1 11.2-8.7 22.7-22.8 22.7-61.2 0-12.5-.9-24.3-2.8-35.1-4.2-24.7-13.2-44.9-27.1-59.6-19.3-20.5-47.1-28.2-74.6-28.2-31.7 0-56.5 10.1-73.9 28.6-13.9 14.8-23.2 34.9-27.5 59.5-1.9 10.8-2.9 22.4-2.9 34.8.1 38.5 11.5 52.5 22.7 61.2z",
    className: "bot_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.1 296.7c0 1.5 0 3-.1 4.4-1.7-73.4-42.8-118.1-126.1-118.1-80.6 0-124.3 44.7-126.1 118.1 0-1.5-.1-2.9-.1-4.4 0-76.3 43.8-122.9 126.2-122.9 85.1 0 126.2 46.6 126.2 122.9z",
    style: {
      fill: "#b3b3b3"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M333.1 449.1zm0 244.5h.2-.2z",
    className: "bot_svg__st10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M494.2 302.2c0 85.6-66.4 110.3-149.8 111.6 75.2-1.5 135-26.2 135-111.6 0-75.6-19.6-150.2-98.2-169.9-2.8-.7-5.6-1.3-8.5-1.9-3-.6-6-1.1-9.2-1.5-2.2-.3-4.4-.6-6.7-.8-4.7-.5-9.6-.7-14.6-.9 5.8.1 11.3.4 16.7.9 2.5.2 5 .5 7.4.8 3.5.4 6.8.9 10.1 1.5 3.2.5 6.3 1.2 9.3 1.9 86.8 19.6 108.5 94.3 108.5 169.9zM321.9 413.7c-81.7-1.9-146.3-27.1-146.3-111.5 0-73.2 29.1-145.6 104.9-167.9 4.6-1.4 9.4-2.5 14.3-3.5 4.3-.9 8.7-1.6 13.3-2.1 1.6-.2 3.2-.4 4.8-.5 4.9-.5 10-.8 15.2-.9-4.6.1-9 .4-13.3.9-1.5.2-2.9.3-4.4.5-4.1.5-8.1 1.2-12.1 2.1-4.5 1-8.8 2.1-12.9 3.5-68.7 22.3-95 94.6-95 167.9 0 84 58 109.3 131.5 111.5z",
    className: "bot_svg__st6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357 501.9c-.2 4.4 3.5 7.9 8.2 7.9 4.7 0 8.7-3.5 9-7.9.3-4.5-3.4-8.1-8.2-8.1-4.8-.1-8.9 3.6-9 8.1zm-55.5 7.9h40.3c1.6 0 2.9-1.2 2.9-2.6l.2-10.6c0-1.5-1.3-2.7-2.9-2.7h-41.3c-1.6 0-2.8 1.2-2.8 2.7l.6 10.6c.1 1.4 1.4 2.6 3 2.6zm15.4 49.4-.9-35.3c0-1.2-1.1-2.1-2.4-2.1h-12c-1.3 0-2.3.9-2.2 2.1l1.9 35.3c.1 1 1.1 1.9 2.3 1.9h11.2c1.2 0 2.1-.9 2.1-1.9zm13.5 1.9H368c1.3 0 2.4-.9 2.4-2l.6-9.5c.1-1.1-.9-2-2.2-2h-38.5c-1.3 0-2.4.9-2.3 2l.1 9.5c0 1.1 1 2 2.3 2zm25.5-31.9c-.2 4 3.4 7.3 7.8 7.3 4.5 0 8.3-3.2 8.6-7.3.3-4.1-3.2-7.4-7.8-7.4s-8.4 3.4-8.6 7.4zm-28.1 0c0 4 3.7 7.3 8.2 7.3 4.5 0 8.2-3.2 8.2-7.3.1-4.1-3.6-7.4-8.2-7.4s-8.2 3.4-8.2 7.4z",
    style: {
      fill: "#eef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3 497.9c-.1 4.5 3.6 8.1 8.3 8.1s8.7-3.6 9-8.1c.2-4.6-3.5-8.3-8.3-8.3s-8.8 3.7-9 8.3zm-56 8.1H338c1.6 0 2.9-1.2 2.9-2.7l.1-10.9c0-1.5-1.3-2.8-2.9-2.8h-41.8c-1.6 0-2.9 1.3-2.8 2.8l.7 10.9c.2 1.5 1.5 2.7 3.1 2.7zm16.2 50.4-1.4-36c0-1.2-1.1-2.1-2.4-2.1h-12.1c-1.3 0-2.3 1-2.2 2.1l2.3 36c.1 1 1.1 1.9 2.3 1.9h11.3c1.3 0 2.2-.8 2.2-1.9zm13.6 1.9h38c1.3 0 2.4-.9 2.4-2l.5-9.7c.1-1.1-1-2.1-2.3-2.1h-38.9c-1.3 0-2.4.9-2.3 2.1l.2 9.7c.1 1.1 1.1 2 2.4 2zm25.5-32.4c-.1 4.1 3.5 7.4 8 7.4s8.4-3.3 8.6-7.4c.2-4.2-3.3-7.6-8-7.6s-8.5 3.4-8.6 7.6zm-28.4 0c.1 4.1 3.8 7.4 8.3 7.4 4.5 0 8.2-3.3 8.2-7.4 0-4.2-3.7-7.6-8.3-7.6s-8.3 3.4-8.2 7.6z",
    style: {
      fill: "#3636d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.5 495.8c-.1 4.5 3.6 8.2 8.4 8.2s8.8-3.6 9-8.2c.2-4.6-3.5-8.4-8.4-8.4-4.9.1-8.9 3.8-9 8.4zm-56.4 8.2H338c1.6 0 2.9-1.2 2.9-2.7l.1-11c0-1.6-1.3-2.8-2.9-2.8h-42c-1.6 0-2.9 1.3-2.8 2.8l.7 11c.2 1.5 1.5 2.7 3.1 2.7zm16.3 51-1.4-36.4c0-1.2-1.1-2.2-2.4-2.2h-12.1c-1.3 0-2.3 1-2.2 2.2l2.4 36.4c.1 1.1 1.1 1.9 2.3 1.9h11.4c1.1 0 2-.8 2-1.9zm13.7 1.9h38.2c1.3 0 2.4-.9 2.4-2l.5-9.8c.1-1.2-1-2.1-2.3-2.1h-39.1c-1.3 0-2.4.9-2.4 2.1l.2 9.8c.1 1.1 1.2 2 2.5 2zm25.6-32.8c-.1 4.2 3.5 7.5 8 7.5s8.4-3.3 8.6-7.5c.2-4.2-3.4-7.7-8-7.7-4.6.1-8.5 3.5-8.6 7.7zm-28.6 0c.1 4.2 3.8 7.5 8.4 7.5 4.5 0 8.3-3.3 8.3-7.5s-3.7-7.7-8.4-7.7-8.4 3.5-8.3 7.7z",
    style: {
      fill: "#00ecb8"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1 423.7c-3.6 3.8-6.9 9.4-9.4 15.9-2.6 6.8-4 13.7-3.7 19.2.2 5 1.9 8.2 4.3 8.4 2.4.3 6-2.3 9.4-6.7 3.8-4.9 7-11.3 9.1-18 2-6.4 2.7-12.3 2.2-16.7-.5-3.8-1.9-6.3-3.9-6.6-.2 0-.5-.1-.7 0-2.1 0-4.6 1.7-7.3 4.5z",
    className: "bot_svg__st14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M458.2 472.3c4.2-.7 6.5-5.2 6.5-12.6 0-6.5-1.7-14.5-4.8-22.3-2.9-7.4-6.7-13.7-10.6-18-4.1-4.5-8.1-6.4-11.4-5.5-3.3.8-5.3 4.3-5.8 9.8-.5 5.2.4 11.9 2.6 19.2 2.3 7.6 5.8 14.9 9.9 20.5 3.9 5.4 8 8.6 11.7 9 .6 0 1.3 0 1.9-.1z",
    className: "bot_svg__st8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M448.7 423.7c3.6 3.8 6.9 9.4 9.4 15.9 2.6 6.8 4 13.7 3.7 19.2-.2 5-1.9 8.2-4.3 8.4-2.4.3-6-2.3-9.4-6.7-3.8-4.9-7-11.3-9.1-18-2-6.4-2.7-12.3-2.2-16.7.5-3.8 1.9-6.3 3.9-6.6.2 0 .5-.1.7 0 2.1 0 4.7 1.7 7.3 4.5z",
    className: "bot_svg__st14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bot_svg__SVGID_00000111879755964473461500000002372980018846723761_",
    x1: 11052.848,
    x2: 11133.39,
    y1: 10744.358,
    y2: 10744.358,
    gradientTransform: "matrix(-.9994 .03445 .03464 1.0048 10893.775 -10638.493)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67c3a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    style: {
      stopColor: "#69e4f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69e6f6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.3 447.1c-8.5 19.7-15.7 49.9-20.1 85.7-7.1 56.8 5.8 112.6 20.7 127.1 1.6 1.6-.6 4.5 9.5 3.8 9.6-.6 11.4-27 13.4-57.3 1.5-22.5 3.1-47.4 8-72.3 5.5-27.8 11.5-55.9 18.7-76.3 6.2-17.4 5.6-37.7-10-41.7-1.8-.5-3.7-.6-5.7-.5-11.4.7-25.5 10.6-34.5 31.5z",
    style: {
      fill: "url(#bot_svg__SVGID_00000111879755964473461500000002372980018846723761_)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.6 447.6c-8.7 22-15.5 54.7-19.6 88.1-7.8 62.4 9.6 126.7 24.8 126.7 16-.1 11.1-62.3 23.6-122.6 5.9-28.3 12.1-56.1 19.3-76.9 18.7-54.4-27.1-68.5-48.1-15.3z",
    className: "bot_svg__st2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.6 660.8c7-2.2 9.1-25.3 11.5-51.9 1.9-21.2 4.1-45.2 9.1-69.4 5.7-27.7 12.1-56.3 19.3-77.4 5.8-16.7 6.6-36.6-4-43.8 6.7 9.2 5.4 26.6.4 41.6-7.3 21.7-13.6 51.1-19.3 79.6-5 24.9-7.2 49.6-9.1 71.4-1.9 22.2-3.6 41.9-7.9 49.9z",
    className: "bot_svg__st6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bot_svg__SVGID_00000046329475991415872340000009731266656150398097_",
    x1: 2443.888,
    x2: 2524.431,
    y1: 11039.527,
    y2: 11039.527,
    gradientTransform: "matrix(.9994 .03445 -.03464 1.0048 -1614.904 -10638.493)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67c3a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    style: {
      stopColor: "#69e4f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69e6f6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M502.5 447.1c8.5 19.7 15.7 49.9 20.1 85.7 7.1 56.8-5.8 112.6-20.7 127.1-1.6 1.6.6 4.5-9.5 3.8-9.6-.6-11.4-27-13.4-57.3-1.5-22.5-3.1-47.4-8-72.3-5.5-27.8-11.5-55.9-18.7-76.3-6.2-17.4-5.6-37.7 10-41.7 1.8-.5 3.7-.6 5.7-.5 11.4.7 25.5 10.6 34.5 31.5z",
    style: {
      fill: "url(#bot_svg__SVGID_00000046329475991415872340000009731266656150398097_)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M502.2 447.6c8.7 22 15.5 54.7 19.6 88.1 7.8 62.4-9.6 126.7-24.8 126.7-16-.1-11.1-62.3-23.6-122.6-5.9-28.3-12.1-56.1-19.3-76.9-18.7-54.4 27.1-68.5 48.1-15.3z",
    className: "bot_svg__st2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M495.2 660.8c-7-2.2-9.1-25.3-11.5-51.9-1.9-21.2-4.1-45.2-9.1-69.4-5.7-27.7-12.1-56.3-19.3-77.4-5.8-16.7-6.6-36.6 4-43.8-6.7 9.2-5.4 26.6-.4 41.6 7.3 21.7 13.6 51.1 19.3 79.6 5 24.9 7.2 49.6 9.1 71.4 1.9 22.2 3.6 41.9 7.9 49.9z",
    className: "bot_svg__st6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bot_svg__left_eye",
    d: "M310.1 305.2v-38.6c0-6.2-5-11.3-11.3-11.3-6.2 0-11.3 5-11.3 11.3v38.6c0 6.2 5 11.3 11.3 11.3 6.3 0 11.3-5.1 11.3-11.3z",
    style: {
      fill: "#67c3a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bot_svg__right_eye",
    d: "M379.2 305.2v-38.6c0-6.2-5-11.3-11.3-11.3-6.2 0-11.3 5-11.3 11.3v38.6c0 6.2 5 11.3 11.3 11.3 6.2 0 11.3-5.1 11.3-11.3z",
    style: {
      fill: "#00f2b6"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M320 767.8c-65.6-3.8-67.1-41.2-71.3-73.7 2.1 2.5 5.4 4.7 9.8 6.7 1.7 31 16.1 64.4 61.5 67zm26.6 0c65.6-3.8 67.1-41.2 71.3-73.7-2.1 2.5-5.4 4.7-9.8 6.7-1.7 31-16.1 64.4-61.5 67z",
    className: "bot_svg__st10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.b675130f651ebe6dc2be4e27dbd8796a.svg";
export { ForwardRef as ReactComponent };